import styles from './ProcessingScreenLoaderList.module.scss';

export type ProcessingScreenLoaderListProps = {
  list: Array<string>;
};

const initialDelay = 4;

const getAnimationDelay = (index: number) => {
  return index * initialDelay;
};

const ProcessingScreenLoaderList = ({ list }: ProcessingScreenLoaderListProps) => (
  <ul className={styles.list}>
    {list.map((item, idx) => (
      <li key={item} className={styles.listItem} style={{ animationDelay: `${getAnimationDelay(idx)}s` }}>
        <p className={styles.text}>{item}</p>
      </li>
    ))}
  </ul>
);

export default ProcessingScreenLoaderList;
